import React from 'react';
import Icon from '../../../components/AppIcon';

const UsageMetricCard = ({ title, value, trend, icon, color = 'blue' }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600 border-blue-200',
    green: 'bg-green-50 text-green-600 border-green-200',
    purple: 'bg-purple-50 text-purple-600 border-purple-200',
    orange: 'bg-orange-50 text-orange-600 border-orange-200',
    red: 'bg-red-50 text-red-600 border-red-200'
  };

  const isPositiveTrend = trend >= 0;

  return (
    <div className="bg-card rounded-xl border border-border p-4 sm:p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className={`p-2 rounded-lg ${colorClasses?.[color]}`}>
          <Icon name={icon} size={20} strokeWidth={2} />
        </div>
        <div className={`flex items-center gap-1 text-xs font-medium ${
          isPositiveTrend ? 'text-green-600' : 'text-red-600'
        }`}>
          <Icon 
            name={isPositiveTrend ? 'TrendingUp' : 'TrendingDown'} 
            size={14} 
            strokeWidth={2} 
          />
          <span>{Math.abs(trend)}%</span>
        </div>
      </div>
      <div>
        <p className="text-sm text-muted-foreground mb-1">{title}</p>
        <p className="text-2xl sm:text-3xl font-heading font-bold text-foreground">
          {typeof value === 'number' ? value?.toLocaleString() : value}
        </p>
      </div>
    </div>
  );
};

export default UsageMetricCard;